<!-- <div *ngIf="usuario.typ_name == 'PACIENTE'" class="col-md-12">
    <br>
    <div class="minititulo">
         Mi perfil
    </div>

    <div class="titulo">
        <div class="row">
            <div class="col-md-6">

                Mis antecedentes
            </div>
            <div class="col-md-6 contenedor-actualizar">
                <button type="button" class="updatebtn"(click)="update_doc()">
                <p style="margin: 0 25px;">
                    Actualizar
                </p>
            </button>
            </div>
        </div>
    </div>
   <br>
</div> -->

<div *ngIf="usuario.typ_name == 'MEDICO'" class="col-md-12"> <!--  *ngIf="tipo_usuario_name=='PACIENTE'" -->
    <br>
    <div class="minititulo">
         Perfil Paciente
    </div>
    <div class="titulo">
        <div class="row">
            <div class="col-md-6">

                Antecedentes Paciente
            </div>
            <div class="col-md-6 contenedor-actualizar">
                <button type="button" class="updatebtn"
                (click)="update_doc()">
                <p style="margin: 0 25px;">
                    Actualizar
                </p>
            </button>
            </div>
        </div>
    </div>
   <br>
</div>
 <app-antecedentes-medicos [consulta]="consulta"></app-antecedentes-medicos>
